import { useState } from "react";
import Button from "./Button";

## Interactive Example

export function InteractiveButton() {
const [style, setStyle] = useState("primary");
const [size, setSize] = useState("medium");
return (

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
    <select value={style} onChange={(e) => setStyle(e.target.value)}>
      <option value="primary">Primary</option>
      <option value="secondary">Secondary</option>
      <option value="tertiary">Tertiary</option>
      <option value="link">Link</option>
      <option value="remove">Remove</option>
      <option value="green">Green</option>
      <option value="white">White</option>
      <option value="black">Black</option>
    </select>
    <select value={size} onChange={(e) => setSize(e.target.value)}>
      <option value="jumbo">Jumbo</option>
      <option value="large">Large</option>
      <option value="medium">Medium</option>
      <option value="small">Small</option>
      <option value="xsmall">XSmall</option>
    </select>
  </div>
  <Button btnStyle={style} btnSize={size}>
    Click me
  </Button>
</div>
); }

<InteractiveButton />

---

## Styles

<div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
  <Button btnStyle="primary">Primary</Button>
  <Button btnStyle="secondary">Secondary</Button>
  <Button btnStyle="tertiary">Tertiary</Button>
  <Button btnStyle="link">Link</Button>
  <Button btnStyle="remove">Remove</Button>
  <Button btnStyle="green">Green</Button>
  <Button btnStyle="white">White</Button>
  <Button btnStyle="black">Black</Button>
</div>

---

## Sizes

<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
  <Button btnSize="jumbo">Jumbo</Button>
  <Button btnSize="large">Large</Button>
  <Button btnSize="medium">Medium</Button>
  <Button btnSize="small">Small</Button>
  <Button btnSize="xsmall">XSmall</Button>
</div>

---

## States

<div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
  <Button>Normal</Button>
  <Button isPending>Pending</Button>
  <Button disabled>Disabled</Button>
</div>

---

## Full Width

<Button fullWidth>Full Width Button</Button>

---

## With Tooltip

<Button tooltip="This is a helpful tooltip">Hover for tooltip</Button>
